<template>
  <div class="pl-1 pr-1" v-if="isEditEnabled || keepEditable">
    <v-textarea
      autofocus
      dense
      flat
      class="editable-textarea"
      background-color="transparent"
      hide-details="auto"
      rows="2"
      :label="editLabel"
      v-model="currentValue"
      v-if="!selectField"
    />
    <v-select
      dense
      hide-details
      flat
      :label="editLabel"
      :items="listOptions"
      v-model="currentValue"
      v-else
    />
    <v-tooltip bottom color="white" v-if="isActionsEnabled">
      <template v-slot:activator="{ on }">
        <v-btn icon color="error" v-on="on" @click="handleEditCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
      <span class="black--text">{{ keepEditable ? 'Clear' : 'Close' }}</span>
    </v-tooltip>
    <v-tooltip bottom color="white" v-if="isActionsEnabled">
      <template v-slot:activator="{ on }">
        <v-btn icon color="primary" v-on="on" @click.prevent="handleUpdate">
          <v-icon>mdi-check</v-icon>
        </v-btn>
      </template>
      <span class="black--text">Save</span>
    </v-tooltip>
  </div>
  <div class="pa-2" v-else>
    <div>
      <span @dblclick.prevent="handleEditEnabled" v-if="!priceField">
        {{ value || '--' }}
      </span>
      <span @dblclick.prevent="handleEditEnabled" v-else>
        ${{ parseFloat(value).toFixed(2) }}
      </span>
    </div>

    <v-container fluid class="d-flex justify-center">
      <v-tooltip bottom color="white" v-if="!isRowDisabled">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" @click.prevent="handleEditEnabled">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span class="black--text">Click to edit</span>
      </v-tooltip>
      <slot name="actions" />
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'FileTableEditableColumn',
  props: {
    value: {
      default: ''
    },
    keyValue: {
      type: String,
      default: null
    },
    isRowDisabled: {
      type: Boolean,
      default: false
    },
    listOptions: {
      type: Array,
      default: () => []
    },
    editLabel: {
      type: String,
      default: ''
    },
    selectField: {
      type: Boolean,
      default: false
    },
    priceField: {
      type: Boolean,
      default: false
    },
    isNullable: {
      type: Boolean,
      default: false
    },
    keepEditable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isEditEnabled: false,
    currentValue: ''
  }),
  mounted() {
    this.setDefaultValue();
  },
  computed: {
    isActionsEnabled() {
      return this.isEditEnabled || this.currentValue !== this.value;
    }
  },
  methods: {
    setDefaultValue() {
      this.currentValue = this.value;
    },
    handleEditEnabled() {
      if (!this.isRowDisabled) {
        this.isEditEnabled = true;
      }
    },
    handleEditCancel() {
      if (!this.keepEditable) {
        this.isEditEnabled = false;
      } else {
        this.setDefaultValue();
      }
    },
    handleUpdate() {
      const updatePartition = _.set(
        {},
        this.keyValue,
        this.isNullable ? this.currentValue || null : this.currentValue
      );

      this.$emit('onItemUpdate', updatePartition);

      if (!this.keepEditable) {
        this.handleEditCancel();
      }
    }
  }
};
</script>
